import { render } from "./PricingMultiproducto.vue?vue&type=template&id=37346b5a"
import script from "./PricingMultiproducto.vue?vue&type=script&lang=js"
export * from "./PricingMultiproducto.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/ParrillaPrecios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__